import React from 'react'

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import HeroImg2 from '../components/HeroImg2';
import AboutContent from '../components/AboutContent';
import Form from "../components/Form";

const About = () => {
  return (
    <div id="about-top">

      <Navbar />
      <HeroImg2 heading="about me" text="engineer + achiever = leader" />
      <AboutContent />
      <Form />
      {/* <Footer /> */}

    </div>
  )
}

export default About